import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
// import core components
import { queryHelper } from 'helpers';

const Wrapper = styled.button`
  background: ${props => props.theme.colors.white};
  border: ${props => props.theme.borders.card};
  box-sizing: border-box;
  border-radius: ${props => props.theme.borderRadius.round};
  outline: none;
  font-weight: ${props => props.theme.fontWeights.button};

  padding: 10px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: ${props => props.theme.breakpoints.xs}) {
    padding: 7.5px 15px;
  }

  span {
    font-size: 16px;
    line-height: 24px;
    margin-left: 7px;
    color: ${props => props.theme.colors.blue};
    font-weight: ${props => props.theme.fontWeight.button};

    @media (max-width: ${props => props.theme.breakpoints.xs}) {
      font-size: 14px;
    }
  }

  svg {
    width: 20px;
    height: 25px;
    fill: ${props => props.theme.colors.blue};
  }

  &:hover {
    border: 1px solid ${props => props.theme.colors.black};

    span,
    svg {
      color: ${props => props.theme.colors.black};

      @media (max-width: ${props => props.theme.breakpoints.xs}) {
        color: ${props => props.theme.colors.blue};
      }
    }

    @media (max-width: ${props => props.theme.breakpoints.xs}) {
      border: 1px solid transparent;
    }
  }
`;

const IconButton = ({ title, children, handleClick }) => {
  return (
    <Wrapper onClick={handleClick}>
      {children}
      <span>{title}</span>
    </Wrapper>
  );
};

export default IconButton;
